import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Mascot } from "@/components/brand/Mascot";
import { errText } from "@/lib/api";
import { adminLogin, setToken } from "@/lib/admin";

const input = "h-12 w-full border-b-[1.5px] border-ink bg-transparent font-mono text-sm focus:outline-none";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const r = await adminLogin(email, password);
      setToken(r.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(errText(err));
    }
    setBusy(false);
  };

  return (
    <div className="mx-auto max-w-md px-5 py-24" data-testid="admin-login-page">
      <Seo title="Admin login" description="Admin login" path="/admin/login" noindex />
      <Mascot size={48} label="" />
      <h1 className="display mt-8 text-6xl">Admin</h1>
      <form onSubmit={submit} className="mt-10 space-y-6">
        <label className="block"><span className="label text-ink/55">Email</span><input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className={input} autoComplete="username" data-testid="admin-login-email" /></label>
        <label className="block"><span className="label text-ink/55">Password</span><input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className={input} autoComplete="current-password" data-testid="admin-login-password" /></label>
        {error && <p className="font-mono text-xs text-alert" role="alert" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="btn btn-ink w-full" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"} <ArrowRight size={16} /></button>
      </form>
    </div>
  );
}
